import React from 'react'
import { Field } from 'formik'
import { TextField, Select, MenuItem, InputLabel, FormControl, FormHelperText } from '@material-ui/core'
function FormPaymentPage({errors, touched, setFieldValue, values, appId}) {
    return (
        <div style={{display: 'flex', gap:'30px', padding:'0 50px', justifyContent:'center'}}>
            <div className="norFlexCon">
                <FormControl variant="outlined" fullWidth>
                    <InputLabel id="modeLabel">Payment Method</InputLabel>
                    <Field name="paymode" labelId="modeLabel" label="Payment Method" as={Select} fullWidth >
                        <MenuItem value=''>Select Method</MenuItem>
                        <MenuItem value='bank transfer'>Bank Transfer</MenuItem>
                        <MenuItem value='cash'>Cash</MenuItem>
                        <MenuItem value='other'>Other</MenuItem>
                    </Field>
                    <FormHelperText>{touched.paymode && errors.paymode}</FormHelperText>
                </FormControl>
                <Field name="amount" label="Amount *" as={TextField} variant="outlined" fullWidth  error={touched.amount && errors.amount} helperText={touched.amount && errors.amount} />
                <Field name="transactionId" label="Transaction ID / Transaction Details *" as={TextField} variant="outlined" fullWidth  error={touched.transactionId && errors.transactionId} helperText={touched.transactionId && errors.transactionId} />
            </div>
        </div>
    )
}

export default FormPaymentPage

